import { SpecSection } from 'Components/SpecSection';

import { VEHICLE_MOT_FIELDS } from './MotSection.const';
import { useVehicleMot } from './useVehicleMot';

export const MotSection: React.FC = () => {
	const mot = useVehicleMot();

	return <SpecSection data={mot} fields={VEHICLE_MOT_FIELDS} />;
};
